{
  "accordion": {
    "blurb": "一组垂直堆叠的交互式标题，每个标题都显示一部分内容。",
    "contentOne": "是的。它遵循 WAI-ARIA 设计模式。",
    "contentThree": "是的。默认情况下是动画的，但如果您愿意，可以禁用它。",
    "contentTwo": "是的。它带有与其他组件美学匹配的默认样式。",
    "name": "手风琴",
    "triggerOne": "它是否可访问？",
    "triggerThree": "它是否有动画？",
    "triggerTwo": "它是否有样式？"
  },
  "alert": {
    "actionCta": "撤销",
    "actionTitle": "所选电子邮件已被标记为垃圾邮件。",
    "blurb": "用于吸引用户注意力的通知。",
    "errorDescription": "请验证您的账单信息并重试。<ul><li>检查您的卡片详细信息</li><li>验证账单地址</li></ul>",
    "errorDescriptionNative": "请验证您的账单信息并重试。",
    "errorTitle": "无法处理您的付款。",
    "extendedDescription": "这是一个同样长的描述，包含有关警报的详细信息。它展示了组件如何在保持适当的间距、对齐和可读性的同时适应大量内容，适用于不同的屏幕尺寸和视口宽度。这有助于确保无论内容长度如何，用户体验都保持一致。",
    "extendedTitle": "这是一个极长的警报标题，跨越多行以演示组件如何处理非常长的标题，同时保持可读性和适当的文本换行行为",
    "name": "警报",
    "noDescTitle": "此警报没有描述。",
    "successDescription": "这是一个带有图标、标题和描述的警报。",
    "successTitle": "成功！您的更改已保存"
  },
  "alertDialog": {
    "blurb": "一个模态对话框，用重要内容打断用户并期望响应。",
    "description": "此操作无法撤消。这将永久删除您的帐户并从我们的服务器中删除您的数据。",
    "name": "警报对话框",
    "title": "您绝对确定吗？",
    "trigger": "显示对话框"
  },
  "avatar": {
    "blurb": "一个图像组件，提供描述用户的替代表示。",
    "name": "头像"
  },
  "badge": {
    "blurb": "一个小的计数或标签组件，可用于突出显示新项目或未读项目。",
    "default": "默认",
    "destructive": "破坏性",
    "name": "徽章",
    "outline": "轮廓",
    "secondary": "次要"
  },
  "blocks": {
    "title": "区块"
  },
  "breadcrumbs": {
    "title": "面包屑"
  },
  "button": {
    "blurb": "按下时执行操作的可点击元素。",
    "default": "默认",
    "destructive": "破坏性",
    "disabled": "禁用",
    "ghost": "幽灵",
    "large": "大",
    "learnMore": "了解更多",
    "link": "链接",
    "loading": "加载中...",
    "name": "按钮",
    "outline": "轮廓",
    "secondary": "次要",
    "send": "发送",
    "small": "小"
  },
  "card": {
    "image": {
      "description": "这是一个带有图像的卡片。",
      "title": "图像卡片"
    },
    "login": {
      "cta": "登录",
      "ctaGoogle": "使用 Google 登录",
      "description": "在下面输入您的电子邮件以登录您的帐户",
      "emailLabel": "电子邮件",
      "emailPlaceholder": "me@example.com",
      "forgotPassword": "忘记密码？",
      "noAccount": "没有帐户？<a>注册</a>",
      "passwordLabel": "密码",
      "title": "登录您的帐户"
    },
    "meetingNotes": {
      "description": "与客户会议的记录。",
      "title": "会议记录"
    },
    "meta": {
      "content": "内容",
      "contentOnly": "仅内容",
      "footer": "页脚",
      "footerOnly": "仅页脚",
      "headerAndContentDescription": "这是一个带有标题和内容的卡片。",
      "headerAndContentTitle": "标题和内容",
      "headerAndFooterDescription": "这是一个带有标题和页脚的卡片。",
      "headerAndFooterTitle": "标题和页脚",
      "headerContentAndFooterDescription": "这是一个带有标题、内容和页脚的卡片。",
      "headerContentAndFooterTitle": "标题、内容和页脚",
      "headerOnlyDescription": "这是一个带有标题和描述的卡片。",
      "headerOnlyTitle": "仅标题"
    }
  },
  "checkbox": {
    "multi": {
      "description": "选择您希望如何接收通知",
      "email": "电子邮件",
      "label": "通知偏好设置",
      "push": "推送通知",
      "sms": "短信"
    },
    "privacy": "我接受隐私政策",
    "terms": "我接受条款和条件"
  },
  "collapsible": {
    "blurb": "一个促进面板展开或折叠的动态元素。",
    "name": "可折叠"
  },
  "components": {
    "errorMessage": "组件中出现问题：{{name}}",
    "name": "组件",
    "title": "组件"
  },
  "datePicker": {
    "placeholder": "选择日期",
    "required": "必须选择日期"
  },
  "dialog": {
    "form": {
      "description": "在这里对您的个人资料进行更改。完成后点击保存。",
      "nameLabel": "姓名",
      "title": "编辑您的个人资料",
      "trigger": "编辑个人资料",
      "usernameLabel": "用户名"
    },
    "scrollableContent": {
      "description": "这是一个带有可滚动内容的对话框。",
      "title": "可滚动内容",
      "trigger": "可滚动内容"
    },
    "stickyFooter": {
      "description": "这是一个带有可滚动内容和固定页脚的对话框。",
      "title": "固定页脚",
      "trigger": "固定页脚"
    }
  },
  "dropdownMenu": {
    "account": "帐户",
    "billing": "账单",
    "blurb": "向用户显示菜单——例如一组动作或功能——由按钮触发。",
    "name": "下拉菜单",
    "notifications": "通知",
    "upgrade": "升级到专业版"
  },
  "form": {
    "bioDescription": "您可以 @提及其他用户和组织。",
    "bioLabel": "个人简介",
    "bioPlaceholder": "告诉我们关于您的信息",
    "blurb": "此模板中包含的所有输入组件的演示。",
    "emailDescription": "这是将在您的个人资料上显示的电子邮件地址。",
    "emailLabel": "显示电子邮件",
    "emailPlaceholder": "选择电子邮件",
    "name": "表单",
    "nextSubscriptionDateLabel": "下次订阅日期",
    "nextSubscriptionDatePlaceholder": "选择日期",
    "nextSubscriptionTimeLabel": "下次订阅时间",
    "nextSubscriptionTimePlaceholder": "选择时间",
    "notificationsChannelLabel": "频道偏好设置",
    "notificationsSubtitle": "通知",
    "notificationsTypeLabel": "通知我关于...",
    "otpBlurb": "输入发送到 <medium>{{phoneNumber}}</medium> 的 6 位数代码",
    "otpDescription": "带有用于身份验证的 OTP 输入的表单演示。",
    "otpLabel": "OTP 验证",
    "otpTitle": "OTP 表单",
    "subscriptionSubtitle": "订阅",
    "title": "表单",
    "usernameDescription": "这是您的公开显示名称。",
    "usernameLabel": "用户名",
    "usernamePlaceholder": "输入您的用户名",
    "validation": {
      "bioTooLong": "个人简介最多只能有 140 个字符",
      "bioTooShort": "个人简介至少要有 10 个字符",
      "usernameTooShort": "用户名至少要有 3 个字符"
    }
  },
  "hoverCard": {
    "description": "这是一个悬停卡片。它可以包含您喜欢的任何内容，例如文本、图像甚至其他组件。\n\n悬停卡片非常适合提供额外信息而不会使 UI 混乱。它们可以用来显示工具提示、附加详细信息，甚至与悬停项目相关的操作。",
    "title": "悬停卡片",
    "trigger": "悬停在我上面"
  },
  "input": {
    "default": "默认",
    "disabled": "禁用",
    "error": "有错误",
    "file": "文件",
    "number": "数字",
    "password": "密码",
    "phoneNumber": "电话号码",
    "required": "必填",
    "required_label": "您必须输入此字段",
    "search": "搜索"
  },
  "label": {
    "disabled": "禁用",
    "username": "用户名"
  },
  "menubar": {
    "edit": "编辑",
    "editMenu": {
      "copy": "复制",
      "cut": "剪切",
      "find": "查找",
      "findOptions": {
        "find": "查找...",
        "findNext": "查找下一个",
        "findPrevious": "查找上一个",
        "searchWeb": "搜索网络"
      },
      "paste": "粘贴",
      "redo": "重做",
      "undo": "撤消"
    },
    "file": "文件",
    "fileMenu": {
      "newIncognitoWindow": "新建无痕窗口",
      "newTab": "新建标签页",
      "newWindow": "新建窗口",
      "print": "打印...",
      "share": "分享",
      "shareOptions": {
        "emailLink": "通过电子邮件发送链接",
        "messages": "消息",
        "notes": "备注"
      }
    },
    "profiles": "配置文件",
    "profilesMenu": {
      "addProfile": "添加配置文件...",
      "andy": "Andy",
      "benoit": "Benoit",
      "edit": "编辑...",
      "luis": "Luis"
    },
    "view": "查看",
    "viewMenu": {
      "alwaysShowBookmarksBar": "始终显示书签栏",
      "alwaysShowFullUrls": "始终显示完整URL",
      "forceReload": "强制重新加载",
      "hideSidebar": "隐藏侧边栏",
      "reload": "重新加载",
      "toggleFullscreen": "切换全屏"
    }
  },
  "navigationMenu": {
    "backlog": "待办事项",
    "blocks": "区块",
    "blog": "博客",
    "blogDescription": "阅读我们最新的博客文章。",
    "components": "组件",
    "componentsDescription": "浏览库中的所有组件。",
    "documentation": "文档",
    "documentationDescription": "学习如何使用库。",
    "done": "完成",
    "list": "列表",
    "simpleList": "简单列表",
    "toDo": "待办",
    "withIcons": "带图标"
  },
  "orgName": "Mindsea 开发",
  "otpInput": {
    "withCharacters": "带字符",
    "withDigits": "带数字",
    "withDigitsAndCharacters": "带数字和字符"
  },
  "progress": {
    "blurb": "任务或过程进度的视觉表示。",
    "name": "进度"
  },
  "radioGroup": {
    "cardLabel": "卡片",
    "comfortable": "舒适",
    "compact": "紧凑",
    "default": "默认",
    "disabledLabel": "间距（禁用）",
    "planDescription": "选择最适合您团队的计划。",
    "planLabel": "计划",
    "proDescription": "为希望扩展业务的大型团队提供的高级功能。",
    "proLabel": "专业计划",
    "spacingLabel": "间距",
    "starterDescription": "非常适合刚开始使用我们平台的小团队。",
    "starterLabel": "入门计划"
  },
  "scrollArea": {
    "photoBy": "照片由 <bold>{{artist}}</bold> 拍摄",
    "tags": "标签"
  },
  "select": {
    "asyncMultiSelectLabel": "多选（异步）",
    "asyncMultiSelectPlaceholder": "选择您喜爱的宝可梦",
    "asyncSingleSelectLabel": "单选（异步）",
    "asyncSingleSelectPlaceholder": "选择您喜爱的宝可梦",
    "disabled": "禁用",
    "multiSelectLabel": "多选",
    "multiSelectPlaceholder": "选择颜色",
    "singleSelectLabel": "单选",
    "singleSelectPlaceholder": "选择颜色"
  },
  "separator": {
    "blog": "博客",
    "blurb": "在内容之间创建视觉或语义区别。",
    "description": "垂直和水平分隔符。",
    "docs": "文档",
    "name": "分隔符",
    "source": "源码",
    "title": "分隔符"
  },
  "sheet": {
    "editProfile": {
      "description": "在这里对您的个人资料进行更改。完成后点击保存。",
      "nameLabel": "姓名",
      "title": "编辑个人资料",
      "usernameLabel": "用户名"
    }
  },
  "skeleton": {
    "blurb": "表示组件在加载时结构的占位符。",
    "name": "骨架屏"
  },
  "switch": {
    "airplaneMode": "飞行模式",
    "bluetooth": "蓝牙",
    "disabled": "禁用开关",
    "required": "必需开关"
  },
  "table": {
    "caption": "您最近的发票列表",
    "header": {
      "amount": "金额",
      "invoice": "发票",
      "method": "方法",
      "status": "状态"
    },
    "total": "总计"
  },
  "tabs": {
    "account": "帐户",
    "accountDescription": "在这里对您的帐户进行更改。完成后点击保存。",
    "blurb": "一组分层的内容部分——称为标签面板——一次显示一个。",
    "code": "代码",
    "currentPasswordLabel": "当前密码",
    "disabled": "禁用",
    "home": "首页",
    "name": "标签页",
    "nameLabel": "姓名",
    "newPasswordLabel": "新密码",
    "password": "密码",
    "passwordDescription": "在此更改您的密码。保存后，您将被注销。",
    "preview": "预览",
    "savePasswordCta": "保存密码",
    "settings": "设置",
    "usernameLabel": "用户名"
  },
  "text": {
    "blurb": "设计系统排版",
    "copy": "敏捷的棕色狐狸跳过了懒惰的狗。",
    "name": "文本"
  },
  "textarea": {
    "default": "默认",
    "disabled": "禁用",
    "error": "有错误"
  },
  "theme": {
    "blurb": "以下是当前主题中所有颜色的列表。\n在明暗模式之间切换以查看颜色如何适应。",
    "name": "主题",
    "paletteTitle": "调色板",
    "title": "主题",
    "toggle": "切换主题"
  },
  "title": "组件沙盒",
  "toast": {
    "action": "撤销",
    "blurb": "一个非模态通知，临时出现以向用户提供反馈。",
    "default": "事件已创建",
    "description": "星期一，1月3日下午6:00",
    "error": "无法创建事件",
    "info": "请在事件时间前10分钟到达区域",
    "name": "Toast",
    "warning": "事件开始时间不能早于上午8点"
  },
  "tooltip": {
    "blurb": "一个小弹窗，当悬停或聚焦时提供有关元素的附加信息。",
    "content": "添加到库",
    "default": "悬停",
    "extendedContent": "要了解更多关于其工作原理，请查看文档。\n\n如果您有任何问题，请联系我们。",
    "info": "信息",
    "name": "工具提示"
  }
}
